import React from 'react';
// import logo from '@/logo.png';

export const Nav00DataSource = {
  wrapper: { className: 'header0 home-page-wrapper',id:'header' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children: process.env.SOURCE_URL+'/logo.png',//logo,
  },
  Menu: {
    className: 'header0-menu',
    children: [
      { name: 'item0', title: '首页', href: '/' },
      {
        name: 'item1', title: 'CanHealthy系列', href: '/canhealthy',
        children: [
          { name: 'item1', title: '了解CanHealthy', href: '/canhealthy' },
          { name: 'item2', title: 'UDI码追溯系列', href: '/uditrace' },
          { name: 'item3', title: '骨科内固定器械清点系列', href: '/nailtool' },
          { name: 'item4', title: '手术工具清点系列', href: '/surgicaltool' },
        ],
      },
      {
        name: 'item2', title: 'CanFlow系列', href: '/canflow',
        children: [
          { name: 'item1', title: '了解CanFlow', href: '/canflow' },
        ],
      },
      {
        name: 'item3', title: 'CanBeauty系列', href: '/canbeauty',
        children: [
          { name: 'item1', title: '了解CanBeauty', href: '/canbeauty' },
          { name: 'item1', title: '口红质检', href: '/lipstick' },
          { name: 'item1', title: '瓶底喷码质检', href: '/jetcode' },
          { name: 'item1', title: 'CSAR', href: '/csar' },
        ],
      },
      {
        name: 'item4', title: 'CanEnergy系列',  href: '/canenergy',
        children: [
          { name: 'item1', title: '了解CanEnergy', href: '/energy' },
          { name: 'item1', title: '太阳能板质检', href: '/solarpv' },
          { name: 'item1', title: '核电运维', href: '/nuclear' },
        ],
      },
      {
        name: 'item3', title: '关于我们', href: '/contact',
        children: [
          { name: 'item1', title: '了解我们', href: '/about' },
          { name: 'item2', title: '加入我们', href: '/contact' },
          // { name: 'item1', title: '可明管理', href: '#' },
        ]
      },
      {
        name: 'item3', title: 'phone', href: '',

      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
};

export const Footer11DataSource = {
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          className: 'logo',
          children:
            process.env.SOURCE_URL+'/logo.png',
        },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: '不止算法，我们是集成商',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 4,
        className: 'block',
        title: { children: '产品' },
        childWrapper: {
          children: [
            { name: 'link0', href: '/canhealthy', children: 'CanHealthy系列' },
            { name: 'link1', href: '/canflow', children: 'CanFlow系列' },
            { name: 'link2', href: '/canbeauty', children: 'CanBeauty系列' },
            { name: 'link3', href: '/energy', children: 'CanEnergy系列' },
            // { name: 'link4', href: '/contact', children: '其他' },
          ],
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 4,
        className: 'block',
        title: { children: '关于' },
        childWrapper: {
          children: [
            { href: '/about', name: 'link0', children: '了解我们' },
            { href: '/contact', name: 'link1', children: '加入我们' },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 4,
        className: 'block',
        title: { children: '联系方式' },
        childWrapper: {
          children: [
            { href: 'mailto:ai@aicalming.com', name: 'link0', children: <span>商务合作<br/>ai@aicalming.com</span> },
            // { href: 'mailto:hr@calming.com.cn', name: 'link0', children: 'hr@calming.com.cn' },
            { href: '/contact', name: 'link0', children: '了解更多' },
          ],
        },
      },
      {
        name: 'qrcode',
        xs: 24,
        md: 4,
        className: 'block',
        title: { children: '关注' },
        childWrapper: {
          className: 'qrcode',
          children: [
            { href: '#', name: 'image',className:'footer-img' ,children: process.env.SOURCE_URL+'/kmai-qrcode.jpeg' },
            // { href: '#', name: 'image', className:'footer-img' ,children: process.env.SOURCE_URL+'/km-qrcode.jpeg' },
          ],
        },
      },
    ],

  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        ©2022-2025 by <a href="/">CALMING AI</a> All Rights Reserved
      </span>
    ),
  },
};

export const Footer21DataSource = {
  wrapper: { className: ' footer2-wrapper' },
  OverPack: { className: ' footer2', playScale: 0.05 },
  copyright: {
    className: 'copyright',
    children: [

      {
        name: 'group',
        children: '东华大学',
        className: 'copyright-group',
        href:'https://meccol.dhu.edu.cn',
      },
      {
        name: 'image2',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/fgGmQUfiUfSBfvsQpfOj.svg',
        className: 'copyright-line',
      },
      {
        href:'http://calming.com.cn',
        name: 'copyright',
        children: '可明信息',
        className: 'copyright-text',
      },
      // {
      //   name: 'image2',
      //   children:
      //     'https://gw.alipayobjects.com/zos/rmsportal/fgGmQUfiUfSBfvsQpfOj.svg',
      //   className: 'copyright-line',
      // },
      // {
      //   href:'#',
      //   name: 'copyright',
      //   children: '沪ICP备17007010号',
      //   className: 'copyright-text',
      // },
    ],
  },
};
